import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JeeMainsHallTicketVerificationRoutingModule } from './jee-mains-hall-ticket-verification-routing.module';
import { JeeMainsVerificationComponent } from './jee-mains-verification/jee-mains-verification.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { JeeMainsLinkComponent } from './jee-mains-link/jee-mains-link.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    JeeMainsVerificationComponent,
    JeeMainsLinkComponent
  ],
  imports: [
    CommonModule,
    AcademicFormModule,
    JeeMainsHallTicketVerificationRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class JeeMainsHallTicketVerificationModule { }
